var _path;
function _extends() { return _extends = Object.assign ? Object.assign.bind() : function (n) { for (var e = 1; e < arguments.length; e++) { var t = arguments[e]; for (var r in t) ({}).hasOwnProperty.call(t, r) && (n[r] = t[r]); } return n; }, _extends.apply(null, arguments); }
import * as React from "react";
function SvgEdit(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 10,
    height: 10,
    viewBox: "0 0 10 10",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fillRule: "evenodd",
    clipRule: "evenodd",
    d: "M1.6507 6.54222L1.25978 8.23245C1.2463 8.29424 1.24676 8.35827 1.26114 8.41985C1.27551 8.48144 1.30344 8.53903 1.34287 8.58841C1.38231 8.6378 1.43226 8.67774 1.48908 8.70531C1.5459 8.73288 1.60814 8.74739 1.67127 8.74777C1.70069 8.75074 1.73033 8.75074 1.75974 8.74777L3.45713 8.35613L7.59935 4.21874L5.78191 2.40204L5.78057 2.40071L1.6507 6.54222ZM5.78148 3.43062L2.31299 6.90868L2.07732 7.92769L3.0904 7.69394L6.56954 4.21835L5.78148 3.43062ZM8.62602 3.1943C8.66551 3.15453 8.69679 3.10736 8.71806 3.05547C8.73934 3.00358 8.75019 2.94799 8.75 2.8919C8.74981 2.8358 8.73858 2.78029 8.71695 2.72855C8.69532 2.67681 8.66372 2.62985 8.62396 2.59035L7.41007 1.37421C7.33026 1.29466 7.22226 1.25 7.10969 1.25C6.99711 1.25 6.8891 1.29466 6.8093 1.37421L6.1345 2.05025L7.95118 3.87039L8.62602 3.1943Z",
    fill: "#4E4E4E"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgEdit);
export default __webpack_public_path__ + "static/media/Edit.2596f21354e805b9cb501eb7c010996c.svg";
export { ForwardRef as ReactComponent };